export const ANNOTATIONS_COLUMNS = 4;
export const ANNOTATIONS_PER_COLUMN = 6;
